import {Component, Input, HostListener, OnDestroy, ViewChild, Output, EventEmitter} from '@angular/core';
import {ApiService} from '../shared/api.service';
import { Utils } from '../utils';

@Component({
    selector: 'affiliates-component',
    templateUrl: 'affiliates.component.html'
})
export class AffiliatesComponent implements OnDestroy {
    heartbeatSubscription;
    options = [];
    panelOpen = false;
    searchText = '';
    selected = '';

    private _affiliated = false;
    private _affiliates = '';
    private _canEdit = false;

    @Input()
    set affiliated(affiliated) {
        this._affiliated = affiliated;
    }
    get affiliated() {
        return this._affiliated;
    }
    @Input()
    set affiliates(affiliates) {
        this._affiliates = affiliates;
    }
    get affiliates() {
        return this._affiliates;
    }
    @Input()
    set canEdit(value) {
        this._canEdit = value;
    }
    get canEdit() {
        return this._canEdit;
    }

    @Output() affiliatesChange = new EventEmitter();
    @Output() affiliatedChange = new EventEmitter();

    @ViewChild('searchInput') searchInput;
    @ViewChild('dropdown') dropdown;

    @HostListener('document:keydown.escape', ['$event'])
    closePanel() {
        this.toggleOptionsPanel(false);
    }
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if( this.dropdown && !this.dropdown.nativeElement.contains(event.target)) {
            this.toggleOptionsPanel(false);
        }
    }

    constructor(private api: ApiService, public utils: Utils) {
        this.options = this.api.getProp('affiliates');
        if( this.options.length ) {
            this.selected = this.options[0];
        }
        this.heartbeatSubscription = this.api.heartbeat.subscribe(() => {
            const apiAffiliates = this.api.getProp('affiliates');
            for(var i = 0; i < apiAffiliates.length; i++) {
                const value = apiAffiliates[i];
                if( !this.listHasItem(this.options, value) ) {
                    this.addOption(value, false);
                }
            }
        });
    }
    affiliateList() {
        if( !this.affiliates ) {
            return [];
        }
        return this.affiliates.split(',');
    }
    addOption(value, addAffiliate) {
        value = value.trim();
        const selected = this.selected;
        if( !value && !selected) {
            return;
        }
        if( !value && selected ) {
            value = selected;
        }
        this.selected = '';
        this.searchText = '';
        this.toggleOptionsPanel(false);
        if( this.listHasItem(this.options, value) ) {
            if( addAffiliate ) {
                this.addAffiliate(value);
                this.toggleOptionsPanel(true);
            }            
            return;
        }
        if( addAffiliate ) {
            this.addAffiliate(value);
            this.toggleOptionsPanel(true);
        }        
        this.options.push(value);
        this.options.sort();
        this.api.setProp('affiliates', this.options);
    }
    addAffiliate(value) {
        value = value.trim();
        if( !value ) {
            return;
        }
        const affiliates = this.affiliateList();
        if( this.listHasItem(affiliates, value) ) {
            return;
        }
        affiliates.push(value);
        affiliates.sort();
        this.affiliates = affiliates.join(',');
        this.affiliatesChange.emit(this.affiliates);
    }
    removeAffiliate(value) {
        const affiliates = this.affiliateList();
        let i = affiliates.length;
        while(i--) {
            if( value.toLowerCase() == affiliates[i].toLowerCase() ) {
                affiliates.splice(i, 1);
            }
        }
        this.affiliates = affiliates.join(',');
        this.affiliatesChange.emit(this.affiliates);
    }
    listHasItem(list, value) {
        const found = list.filter(item => value.toLowerCase() == item.toLowerCase()).shift();
        if( found ) {
            return true;
        }
        return false;
    }
    toggleOptionsPanel(open, e = null) {
        setTimeout(() => {
            if( open === false ) {
                this.panelOpen = false;
            } else {
                this.panelOpen = true;
            }
        }, 100);
    }
    isSelected(option) {
        if( option.toLowerCase() == this.selected.toLowerCase() ) {
            return true;
        }
        return false;
    }
    selectUp() {
        const options = this.options;
        const len = options.length;
        if( len == 0 ) {
            return;
        }
        this.toggleOptionsPanel(true)
        const last = len - 1;
        if( !this.selected ) {
            this.selected = options[last];
            return;
        }
        const index = options.indexOf(this.selected);
        let prev = index - 1;
        if( prev < 0 ) {
            prev = last;
        }
        this.selected = options[prev];
    }
    selectDown() {
        const options = this.options;
        const len = options.length;
        if( len == 0 ) {
            return;
        }
        this.toggleOptionsPanel(true);
        if( !this.selected ) {
            this.selected = options[0];
            return;
        }
        const index = options.indexOf(this.selected);
        let next = index + 1;
        if( next > len ) {
            next = 0;
        }
        this.selected = options[next];
    }
    backspace() {
        if( this.searchText ) {
            return;
        }
        const affiliates = this.affiliateList();
        affiliates.pop();
        this.affiliates = affiliates.join(',');
        this.affiliatesChange.emit(this.affiliates);
    }
    optionClick(option) {
        this.addAffiliate(option);
        this.toggleOptionsPanel(false);
    }
    checkboxChange(e) {
        if( !e.checked ) {
            this.affiliates = '';
            this.affiliatesChange.emit(this.affiliates);
        }
        this.affiliatedChange.emit(this.affiliated);
    }
    ngOnDestroy() {
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
}